import React, { Fragment, ImgHTMLAttributes } from "react";

type AvatarProps = ImgHTMLAttributes<HTMLImageElement> & {
  size?: string;
};

export const Avatar: React.FC<AvatarProps> = ({
  size = "smallxs",
  ...props // Spread para el resto de los props de img
}) => {
  const sizes: any = {
    smallxs: "h-6 w-6",
    small: "h-8 w-8",
    medium: "h-10 w-10",
    large: "h-12 w-12",
    extraLarge: "h-14 w-14",
    huge: "h-32 w-32",
  };
  return (
    <Fragment>
      <img
        {...props}
        className={`inline-block ${sizes[size ?? "smallxs"]} rounded-md`}
      />
    </Fragment>
  );
};
